<template>
  <div class="header-bar">
    <div class="fixed transition-all w-full duration-300 t-0 z-300"  v-if="isHome">
      <DownTip v-if="!isApp&&!isIOSWebClip()" @onclose="handleDownClose" />
      <Header
        @onmenu="handleMenu"
        @oncash="handleCashVfm"
        :showCash="showCash"
      />
    </div>
    <slot />
    <Tabbar />

    <!-- 左侧弹出 -->
    <MenuVfm ref="menuVfm" />
    <!-- 余额弹出 -->
     <div v-if="showCash" @click="handleCashVfm" class="cash-vfm-pop w-full fixed  t-0  z-610 bg-color"></div>
    <div
      class="cash-vfm w-full h-full fixed z-610 bg-color"
      :class="[
        showCash
          ? 'cash-vfm-open transition-all duration-300 opacity-100'
          : 'cash-vfm-close opacity-0'
      ]"
    >
      <!-- 背景 -->
      <div
        class="fixed w-full h-full z-611 bg-color t-0 "
        :class="[showCash ? 'pointer-events-auto' : 'pointer-events-none']"
        @click="handleCashVfm"
      ></div>
      <!-- 内容 -->
      <div
        class="relative z-612 bg-color-4 box-shadow-02 h-[max-content] flex-col rounded-bl-15 rounded-br-15 overflow-hidden pt-15"
      >
        <div
          class="px-20 flex-1 flex-col overflow-hidden pb-15 text-color-0 text-12 font-700"
        >
          <div
            class="flex justify-between items-center min-h-40 max-h-52 py-5 px-5 rounded-5 border-1 border-solid border-color-main-1"
          >
            <div class="flex items-center">
              <!-- <BS /> -->
              <span class="ml-4">{{ $C.UNIT }}</span>
            </div>
            <div class="flex items-center">
              <span class="whitespace-pre">
                {{ $C.UNIT }}
                <span>{{ userinfo && userinfo.money }}</span>
                <!-- <R$ :value="userinfo && userinfo.vip_coin" /> -->
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import eventBus from "@/utils/eventBus";

import DownTip from "./DownTip.vue";
import Header from "./Header.vue";
import { useAppStore } from "../../stores/modules/app";
import BS from "@/components/BS.vue";
import { useUserStore } from "../../stores/modules/user";
import { computed, ref } from "vue";
import Utils from "../../utils/util";
import MenuVfm from "@/components/vfm/phone/Menu.vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isHome = computed(() => route.path === "/home");
const appStore = useAppStore();
const userStore = useUserStore();

const userinfo = computed(() => {
  return userStore.userinfo;
});
const showCash = ref(false);
const menuVfm = ref();
function isIOSWebClip() {
  return (
    /iphone|ipad|ipod/i.test(navigator.userAgent) &&
    window.navigator.standalone === true
  );
}
const isApp = typeof window.plus !== "undefined";
onMounted(() => {
  if(isApp || isIOSWebClip()){
    appStore.updateShowAppDown(false);
  }
});
onUnmounted(() => {
});

function handleCashVfm() {
  showCash.value = !showCash.value;
}
function handleMenu() {
  menuVfm.value.handleMenu();
}
const handleDownClose = () => {
  document.documentElement.style.setProperty("--app-download-height", "0px");
  appStore.updateShowAppDown(false);
};
</script>
<style lang="scss" scoped>
.layout-container{
  max-width: 540px; 
  margin: auto !important;
  background-color: #1a3a0a;
  background-image: none;
}
.cash-vfm {
  top: calc(55px + var(--app-download-height));
}
.cash-vfm-pop{
  height: calc(55px + var(--app-download-height));
}
.cash-vfm-open {
  transform: translateY(0px);
}
.cash-vfm-close {
  z-index: -10;
  transform: translateY(-170px);
}
.bg-color{
  background-color: rgb(0,0,0,0) !important;
}
</style>
